export const simulation = {
    title: 'シミュレーション',

    tableCompanyName: '企業名',
    tableTitle: 'table',

    valueChainLabel: 'バリューチェーン',
    naceLabel: 'プロセス',
    usLabel: '産業分類',
    ipcLabel: 'クラスタを選択',
    ecoSystemGroupCompanies: 'グループ企業',
    ecoSystemEcosystem: 'エコシステム',
    ecoSystemDefault: 'デフォルト',
    modeselect: 'モード選択',

    selectTable: '仮想提携リスト',
    selectTableCompanyName: '企業',
    selectTableCompanyNameAllianceBenefit: '提携スコア',
    selectTableScore: 'スコア',
    selectTableImpact: 'インパクト',
    selectTableScale: '事業規模[千米ドル]',
    selectTableMarketability: 'マイノリティ出資額[百万円]',
    selectTableFoundationFiscalYear: '設立年',
    selectTableStartupPhase: '成長ステージ',

    chart: 'シナジー分析 – イノベーション評価',
    pre: '提携前',
    post: '提携後',
    yAxis: 'Y軸',

    type: 'タイプ',
    selectCompanyPost: '選択した企業（提携後）',
    selectCompanyPre: '選択した企業（提携前）',
    otherCompany: 'その他の企業',
    selectedCompanyWithLabel: '選択した企業を含ラベル',

    themeTableTitle: 'シナジー分析 – 選択したテーマとの親和性が高い企業',
    companyTableTitle: 'シナジー分析 – 選択した企業との親和性が高いテーマ',
    themeTableCompanyName: 'テーマとの親和性が高い企業',
    themeTableRankPre: '順位 (提携前)',
    themeTableRankPost: '順位 (提携後)',
    themeTableAffinityPre: '親和性 (提携前)',
    themeTableAffinityPost: '親和性 (提携後)',
    themeTableAffinityDiff: '差分',

    companyTableThemeName: 'テーマ',
    companyTableRankPre: '順位 (提携前)',
    companyTableRankPost: '順位 (提携後)',
    companyTableAffinityPre: '親和性 (提携前)',
    companyTableAffinityPost: '親和性 (提携後)',
    companyTableAffinityDiff: '差分',
    companyTableAmountPre: 'マイノリティ投資額 (提携前)',
    companyTableAmountPost: 'マイノリティ投資額 (提携後)',

    // Switch btn and RadioGroup
    CompanySelectMode: '企業選択',
    LabelFixMode: 'ラベル固定',
    labelShowMore: '企業名、特許出願件数',
    labelShowOnlyCluster: '企業名のみ'
}
